import { useState, useEffect, useCallback, Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  render() {
    if (this.state.error) return (
      <div style={{ padding: 32, textAlign: "center", color: "#D4563A", fontFamily: "sans-serif" }}>
        <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 12 }}>Sayfa yüklenemedi</div>
        <div style={{ fontSize: 13, color: "#5A6670", marginBottom: 20 }}>{String(this.state.error)}</div>
        <button onClick={() => window.location.reload()} style={{ padding: "10px 20px", borderRadius: 10, border: "none", background: "#0C6B58", color: "#fff", fontWeight: 600, cursor: "pointer" }}>
          Yenile
        </button>
      </div>
    );
    return this.props.children;
  }
}

// ─── API Config ─────────────────────────────────────────────
const _rawBase = process.env.REACT_APP_API_URL || "http://localhost:8000";
const API_BASE = (typeof window !== "undefined" &&
  window.location.protocol === "https:" &&
  _rawBase.startsWith("http://"))
  ? _rawBase.replace("http://", "https://")
  : _rawBase;
const CURRENT_YEAR = new Date().getFullYear();

const LS_TOKEN = "mobil_token";
const LS_USER  = "mobil_user";

const api = {
  get token() { return localStorage.getItem(LS_TOKEN); },
  get user()  { try { return JSON.parse(localStorage.getItem(LS_USER)); } catch { return null; } },
  _save(token, user) {
    localStorage.setItem(LS_TOKEN, token);
    localStorage.setItem(LS_USER, JSON.stringify(user));
  },
  _clear() {
    localStorage.removeItem(LS_TOKEN);
    localStorage.removeItem(LS_USER);
  },
  async login(username, password) {
    const form = new URLSearchParams();
    form.append("username", username);
    form.append("password", password);
    const res = await fetch(`${API_BASE}/api/token`, { method: "POST", body: form });
    if (!res.ok) { const err = await res.json(); throw new Error(err.detail || "Giriş başarısız"); }
    const data = await res.json();
    if (data.status === "otp_required") return { otp_required: true, mesaj: data.mesaj };
    this._save(data.access_token, data.user);
    return data;
  },
  async verifyOtp(username, otp) {
    const form = new URLSearchParams();
    form.append("kullanici_adi", username);
    form.append("otp", otp);
    const res = await fetch(`${API_BASE}/api/token/dogrula`, { method: "POST", body: form });
    if (!res.ok) { const err = await res.json(); throw new Error(err.detail || "Kod hatalı"); }
    const data = await res.json();
    this._save(data.access_token, data.user);
    return data;
  },
  async get(path) {
    const res = await fetch(`${API_BASE}${path}`, {
      headers: { Authorization: `Bearer ${this.token}` },
    });
    if (res.status === 401) { this._clear(); throw new Error("UNAUTHORIZED"); }
    if (!res.ok) throw new Error(`API Hata: ${res.status}`);
    return res.json();
  },
};

// ─── Icons ──────────────────────────────────────────────────
const Icon = ({ type, size = 20, color = "currentColor" }) => {
  const icons = {
    home: <path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0a1 1 0 01-1-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1m-2 0h2" />,
    building: <path d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />,
    chart: <path d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />,
    cow: <path d="M12 4.5c-1.5-2-4-2-5.5-.5S4 7 5 9c-2 1-3 3-2 5s3 3 5 3h8c2 0 4-1 5-3s0-4-2-5c1-2 .5-4.5-1-6s-4-1.5-5.5.5zM9 14a1 1 0 100 2 1 1 0 000-2zm6 0a1 1 0 100 2 1 1 0 000-2z" />,
    users: <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2m22 0v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75M9 7a4 4 0 100 8 4 4 0 000-8z" />,
    back: <path d="M19 12H5m7-7l-7 7 7 7" />,
    land: <path d="M3 21h18M3 21l4-7 4 4 4-8 4 11" />,
    search: <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />,
    close: <path d="M6 18L18 6M6 6l12 12" />,
    milk: <path d="M8 2h8l2 4v14a2 2 0 01-2 2H8a2 2 0 01-2-2V6l2-4zm0 8h8" />,
    lock: <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />,
    user: <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 3a4 4 0 100 8 4 4 0 000-8z" />,
    logout: <path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />,
    refresh: <path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />,
    wheat: <path d="M12 2v20M8 6c0 0 1 2 4 2s4-2 4-2M8 10c0 0 1 2 4 2s4-2 4-2M8 14c0 0 1 2 4 2s4-2 4-2" />,
    leaf: <path d="M17 8C8 10 5.9 16.17 3.82 22M9.09 9.91A5 5 0 0113 22M12 2a10 10 0 0110 10c0 4-2.5 8-6.5 9.5" />,
    bee: <path d="M12 2c2 0 4 1 5 3m-5-3c-2 0-4 1-5 3m5-3v3m-5 3c0 5 2 9 5 10 3-1 5-5 5-10M7 8h10M8 12h8m-6 4h4" />,
    chevron: <path d="M19 9l-7 7-7-7" />,
  };
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      {icons[type]}
    </svg>
  );
};

// ─── Helpers ────────────────────────────────────────────────
const fmt = (n) => {
  if (n == null || isNaN(n)) return "0";
  return Number(n).toLocaleString("tr-TR");
};
const fmtDa = (n) => {
  if (!n) return "0";
  return Number(n).toLocaleString("tr-TR", { maximumFractionDigits: 1 }) + " da";
};

const AY_KISA = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"];

// ─── Expandable Section ─────────────────────────────────────
const ExpandableSection = ({ title, defaultOpen = false, children, badge, color = "#0C6B58" }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{ background: "#fff", borderRadius: 20, marginBottom: 12, border: "1px solid #E8E4DE", overflow: "hidden" }}>
      <div
        onClick={() => setOpen(v => !v)}
        style={{
          display: "flex", alignItems: "center", justifyContent: "space-between",
          padding: "16px 18px", cursor: "pointer", userSelect: "none",
          borderBottom: open ? "1px solid #F0EDE8" : "none",
          transition: "border-color 0.2s",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ width: 4, height: 20, borderRadius: 2, background: color }} />
          <span style={{ fontSize: 17, fontWeight: 700, color: "#1A1A1A" }}>{title}</span>
          {badge != null && (
            <span style={{ fontSize: 13, fontWeight: 600, color, background: color + "15", padding: "3px 10px", borderRadius: 20 }}>
              {badge}
            </span>
          )}
        </div>
        <div style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.25s ease" }}>
          <Icon type="chevron" size={18} color="#9BA5AE" />
        </div>
      </div>
      <div style={{
        maxHeight: open ? 2000 : 0,
        overflow: "hidden",
        transition: "max-height 0.35s cubic-bezier(.4,0,.2,1)",
      }}>
        <div style={{ padding: "16px 18px 18px" }}>
          {children}
        </div>
      </div>
    </div>
  );
};

// ─── Mini Bar Chart ─────────────────────────────────────────
const MiniBar = ({ data, dataKey, color, label }) => {
  const max = Math.max(...data.map((d) => d[dataKey] || 0), 1);
  return (
    <div style={{ marginTop: 16 }}>
      <div style={{ fontSize: 14, fontWeight: 600, color: "#5A6670", marginBottom: 8 }}>{label}</div>
      <div style={{ display: "flex", alignItems: "flex-end", gap: 3, height: 80 }}>
        {data.map((d, i) => (
          <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
            <div style={{
              width: "100%", borderRadius: "3px 3px 0 0",
              background: (d[dataKey] || 0) > 0 ? color : "#EDEBE7",
              height: Math.max(3, ((d[dataKey] || 0) / max) * 56),
              transition: "height 0.5s cubic-bezier(.4,0,.2,1)",
              opacity: (d[dataKey] || 0) > 0 ? 1 : 0.3,
            }} />
            <span style={{ fontSize: 11, color: "#9BA5AE", fontWeight: 500 }}>{AY_KISA[i]}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

// ─── Circular Progress ──────────────────────────────────────
const CircleProgress = ({ value, max, color, label, sub }) => {
  const pct = max > 0 ? Math.min((value / max) * 100, 100) : 0;
  const r = 34; const c = 2 * Math.PI * r;
  return (
    <div style={{ textAlign: "center" }}>
      <svg width="84" height="84" viewBox="0 0 84 84">
        <circle cx="42" cy="42" r={r} fill="none" stroke="#EDEBE7" strokeWidth="7" />
        <circle cx="42" cy="42" r={r} fill="none" stroke={color} strokeWidth="7"
          strokeDasharray={c} strokeDashoffset={c - (c * pct) / 100}
          strokeLinecap="round" transform="rotate(-90 42 42)"
          style={{ transition: "stroke-dashoffset 1s cubic-bezier(.4,0,.2,1)" }} />
        <text x="42" y="38" textAnchor="middle" fill="#1A1A1A" fontSize="14" fontWeight="700">{fmt(value)}</text>
        <text x="42" y="52" textAnchor="middle" fill="#9BA5AE" fontSize="10">{sub}</text>
      </svg>
      <div style={{ fontSize: 13, fontWeight: 600, color: "#5A6670", marginTop: 2 }}>{label}</div>
    </div>
  );
};

// ─── Irk Kartı ──────────────────────────────────────────────
const IrkKart = ({ irk }) => {
  const [acik, setAcik] = useState(false);
  const satirlar = [
    { label: "İnek",      value: irk.inek,      color: "#D4563A" },
    { label: "Boğa",      value: irk.boga,      color: "#8B2500" },
    { label: "Genç Boğa", value: irk.genc_boga, color: "#B5432E" },
    { label: "Düve",      value: irk.duve,       color: "#E8A838" },
    { label: "Dana (E)",  value: irk.dana_erkek, color: "#3478C6" },
    { label: "Dana (D)",  value: irk.dana_disi,  color: "#7C5CBF" },
  ].filter(s => s.value > 0);

  return (
    <div style={{ background: "#F8F6F2", borderRadius: 16, overflow: "hidden", border: "1px solid #EDE9E3" }}>
      {/* Başlık satırı — tıklanabilir */}
      <div onClick={() => setAcik(v => !v)} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 18px", cursor: "pointer" }}>
        <div>
          <div style={{ fontSize: 16, fontWeight: 800, color: "#1A1A1A" }}>{irk.irk}</div>
          <div style={{ fontSize: 13, color: "#9BA5AE", marginTop: 3 }}>
            <span style={{ fontWeight: 700, color: "#D4563A" }}>{fmt(irk.toplam_hayvan)} baş</span>
            {irk.sut_kg > 0 && <span> · {fmt(irk.sut_kg)} kg süt</span>}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ background: "#D4563A18", borderRadius: 20, padding: "5px 14px", fontSize: 14, fontWeight: 700, color: "#D4563A" }}>
            {fmt(irk.toplam_hayvan)} baş
          </div>
          <div style={{ transform: acik ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.22s ease" }}>
            <Icon type="chevron" size={18} color="#9BA5AE" />
          </div>
        </div>
      </div>
      {/* Detay içeriği */}
      <div style={{ maxHeight: acik ? 600 : 0, overflow: "hidden", transition: "max-height 0.3s cubic-bezier(.4,0,.2,1)" }}>
        <div style={{ padding: "0 18px 18px", borderTop: "1px solid #EDE9E3" }}>
          {/* Hayvan alt grupları */}
          {satirlar.length > 0 && (
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginTop: 14 }}>
              {satirlar.map(s => (
                <div key={s.label} style={{ background: "#fff", borderRadius: 12, padding: "12px 10px", textAlign: "center" }}>
                  <div style={{ fontSize: 12, color: "#9BA5AE", fontWeight: 600 }}>{s.label}</div>
                  <div style={{ fontSize: 18, fontWeight: 800, color: s.color, marginTop: 4 }}>{fmt(s.value)}</div>
                  <div style={{ fontSize: 11, color: "#9BA5AE" }}>baş</div>
                </div>
              ))}
            </div>
          )}
          {/* Süt + buzağı + satış */}
          <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
            {irk.sut_kg > 0 && (
              <div style={{ flex: 1, background: "#EBF3FC", borderRadius: 12, padding: "12px 10px", textAlign: "center" }}>
                <div style={{ fontSize: 12, color: "#3478C6", fontWeight: 600 }}>Süt</div>
                <div style={{ fontSize: 16, fontWeight: 800, color: "#3478C6", marginTop: 4 }}>{fmt(irk.sut_kg)}</div>
                <div style={{ fontSize: 11, color: "#3478C6", opacity: 0.7 }}>kg</div>
              </div>
            )}
            {irk.buzagi > 0 && (
              <div style={{ flex: 1, background: "#FEF7E8", borderRadius: 12, padding: "12px 10px", textAlign: "center" }}>
                <div style={{ fontSize: 12, color: "#C48820", fontWeight: 600 }}>Buzağı</div>
                <div style={{ fontSize: 16, fontWeight: 800, color: "#C48820", marginTop: 4 }}>{fmt(irk.buzagi)}</div>
                <div style={{ fontSize: 11, color: "#C48820", opacity: 0.7 }}>doğum</div>
              </div>
            )}
            {irk.satis > 0 && (
              <div style={{ flex: 1, background: "#EAF4F0", borderRadius: 12, padding: "12px 10px", textAlign: "center" }}>
                <div style={{ fontSize: 12, color: "#0C6B58", fontWeight: 600 }}>Satış</div>
                <div style={{ fontSize: 16, fontWeight: 800, color: "#0C6B58", marginTop: 4 }}>{fmt(irk.satis)}</div>
                <div style={{ fontSize: 11, color: "#0C6B58", opacity: 0.7 }}>baş</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// ─── KucukbasIrkKart ────────────────────────────────────────
const KucukbasIrkKart = ({ irk }) => {
  const [acik, setAcik] = useState(false);
  const detaylar = [
    { label: "Koç/Teke", value: irk.koc_teke, color: "#3478C6" },
    { label: "Ana Hayvan", value: irk.ana_sayisi, color: "#7C5CBF" },
    { label: "Sağmal", value: irk.sagmal, color: "#E8A838" },
    { label: "Erkek Toklu", value: irk.erkek_toklu, color: "#3478C6" },
    { label: "Dişi Toklu", value: irk.disi_toklu, color: "#7C5CBF" },
  ].filter(d => d.value > 0);
  return (
    <div style={{ background: "#F8F6F2", borderRadius: 16, overflow: "hidden", border: "1px solid #EDE9E3" }}>
      <div onClick={() => setAcik(v => !v)} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 16px", cursor: "pointer" }}>
        <div>
          <div style={{ fontSize: 15, fontWeight: 800, color: "#1A1A1A" }}>{irk.irk}</div>
          <div style={{ fontSize: 12, color: "#9BA5AE", marginTop: 2 }}>
            <span style={{ fontWeight: 700, color: "#7C5CBF" }}>{fmt(irk.toplam_hayvan)} baş</span>
            {irk.sut_kg > 0 && <span> · {fmt(irk.sut_kg)} kg süt</span>}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ background: "#7C5CBF18", borderRadius: 20, padding: "4px 12px", fontSize: 13, fontWeight: 700, color: "#7C5CBF" }}>
            {fmt(irk.toplam_hayvan)} baş
          </div>
          <div style={{ transform: acik ? "rotate(180deg)" : "rotate(0)", transition: "transform 0.22s" }}>
            <Icon type="chevron" size={18} color="#9BA5AE" />
          </div>
        </div>
      </div>
      <div style={{ maxHeight: acik ? 400 : 0, overflow: "hidden", transition: "max-height 0.3s cubic-bezier(.4,0,.2,1)" }}>
        <div style={{ padding: "0 16px 16px", borderTop: "1px solid #EDE9E3" }}>
          {detaylar.length > 0 && (
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginTop: 12 }}>
              {detaylar.map(d => (
                <div key={d.label} style={{ background: "#fff", borderRadius: 12, padding: "10px", textAlign: "center" }}>
                  <div style={{ fontSize: 11, color: "#9BA5AE", fontWeight: 600 }}>{d.label}</div>
                  <div style={{ fontSize: 16, fontWeight: 800, color: d.color, marginTop: 3 }}>{fmt(d.value)}</div>
                  <div style={{ fontSize: 10, color: "#9BA5AE" }}>baş</div>
                </div>
              ))}
            </div>
          )}
          {irk.sut_kg > 0 && (
            <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
              <div style={{ flex: 1, background: "#EBF3FC", borderRadius: 12, padding: "10px", textAlign: "center" }}>
                <div style={{ fontSize: 11, color: "#3478C6", fontWeight: 600 }}>Süt Üretimi</div>
                <div style={{ fontSize: 16, fontWeight: 800, color: "#3478C6", marginTop: 3 }}>{fmt(irk.sut_kg)} kg</div>
              </div>
              {irk.kuzu_dogum > 0 && (
                <div style={{ flex: 1, background: "#FEF7E8", borderRadius: 12, padding: "10px", textAlign: "center" }}>
                  <div style={{ fontSize: 11, color: "#C48820", fontWeight: 600 }}>Kuzu/Oğlak</div>
                  <div style={{ fontSize: 16, fontWeight: 800, color: "#C48820", marginTop: 3 }}>{fmt(irk.kuzu_dogum)}</div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// ─── Ürün Kartı (tarla/yem/bahçe ürünleri için) ─────────────
const UrunKart = ({ urun, color = "#6B8E23" }) => {
  const [acik, setAcik] = useState(false);
  return (
    <div style={{ background: "#F8F6F2", borderRadius: 14, overflow: "hidden", border: "1px solid #EDE9E3" }}>
      <div onClick={() => setAcik(v => !v)} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "13px 16px", cursor: "pointer" }}>
        <div>
          <div style={{ fontSize: 14, fontWeight: 800, color: "#1A1A1A" }}>{urun.urun}</div>
          <div style={{ fontSize: 12, color: "#9BA5AE", marginTop: 2 }}>
            {urun.uretim_ton > 0 && <span style={{ fontWeight: 700, color }}>{fmt(urun.uretim_ton)} ton</span>}
            {(urun.hasat_da > 0 || urun.ekim_da > 0) && <span> · {fmt(Math.round(urun.hasat_da || urun.ekim_da))} da</span>}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ background: color + "18", borderRadius: 20, padding: "4px 12px", fontSize: 13, fontWeight: 700, color }}>
            {fmt(urun.uretim_ton)} ton
          </div>
          <div style={{ transform: acik ? "rotate(180deg)" : "rotate(0)", transition: "transform 0.22s" }}>
            <Icon type="chevron" size={16} color="#9BA5AE" />
          </div>
        </div>
      </div>
      <div style={{ maxHeight: acik ? 200 : 0, overflow: "hidden", transition: "max-height 0.3s cubic-bezier(.4,0,.2,1)" }}>
        <div style={{ padding: "0 14px 14px", borderTop: "1px solid #EDE9E3" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginTop: 10 }}>
            {(urun.hasat_da > 0 || urun.ekim_da > 0) && (
              <div style={{ background: "#fff", borderRadius: 10, padding: "12px", textAlign: "center" }}>
                <div style={{ fontSize: 11, color: "#9BA5AE", fontWeight: 600 }}>Hasat Alanı</div>
                <div style={{ fontSize: 17, fontWeight: 800, color, marginTop: 3 }}>{fmt(Math.round(urun.hasat_da || urun.ekim_da))}</div>
                <div style={{ fontSize: 10, color: "#9BA5AE" }}>dekar</div>
              </div>
            )}
            {urun.uretim_ton > 0 && (
              <div style={{ background: "#fff", borderRadius: 10, padding: "12px", textAlign: "center" }}>
                <div style={{ fontSize: 11, color: "#9BA5AE", fontWeight: 600 }}>Üretim</div>
                <div style={{ fontSize: 17, fontWeight: 800, color: color + "cc", marginTop: 3 }}>{fmt(urun.uretim_ton)}</div>
                <div style={{ fontSize: 10, color: "#9BA5AE" }}>ton</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// ─── Tesis Grup Kartı (Tesis & Altyapı alt grupları) ────────
const TesisGrupKart = ({ title, fields }) => {
  const [open, setOpen] = useState(false);
  const nonzero = fields.filter(f => (f.value || 0) > 0);
  if (nonzero.length === 0) return null;
  return (
    <div style={{ background: "#fff", borderRadius: 12, marginBottom: 6, overflow: "hidden", border: "1px solid #E8E4DE" }}>
      <div onClick={() => setOpen(v => !v)} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "11px 14px", cursor: "pointer" }}>
        <span style={{ fontSize: 13, fontWeight: 700, color: "#1A1A1A" }}>{title}</span>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 11, color: "#D4563A", fontWeight: 600, background: "#D4563A12", padding: "2px 8px", borderRadius: 20 }}>{nonzero.length} kalem</span>
          <div style={{ transform: open ? "rotate(180deg)" : "rotate(0)", transition: "transform 0.2s" }}>
            <Icon type="chevron" size={15} color="#9BA5AE" />
          </div>
        </div>
      </div>
      <div style={{ maxHeight: open ? 600 : 0, overflow: "hidden", transition: "max-height 0.3s cubic-bezier(.4,0,.2,1)" }}>
        <div style={{ padding: "0 12px 12px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8 }}>
          {nonzero.map(f => (
            <div key={f.label} style={{ background: "#F8F6F2", borderRadius: 10, padding: "12px 12px" }}>
              <div style={{ fontSize: 11, color: "#9BA5AE", fontWeight: 500 }}>{f.label}</div>
              <div style={{ fontSize: 17, fontWeight: 800, color: "#D4563A", marginTop: 3 }}>{fmt(Math.round(f.value))}</div>
              <div style={{ fontSize: 10, color: "#9BA5AE" }}>{f.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// ─── Alt Expandable (içiçe bölümler için) ───────────────────
const SubSection = ({ title, badge, color = "#7C5CBF", children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ background: "#F0EDE8", borderRadius: 14, marginBottom: 8, overflow: "hidden" }}>
      <div onClick={() => setOpen(v => !v)} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "13px 16px", cursor: "pointer" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ width: 3, height: 16, borderRadius: 2, background: color }} />
          <span style={{ fontSize: 15, fontWeight: 700, color: "#1A1A1A" }}>{title}</span>
          {badge != null && (
            <span style={{ fontSize: 12, fontWeight: 600, color, background: color + "20", padding: "2px 8px", borderRadius: 20 }}>{badge}</span>
          )}
        </div>
        <div style={{ transform: open ? "rotate(180deg)" : "rotate(0)", transition: "transform 0.22s" }}>
          <Icon type="chevron" size={16} color="#9BA5AE" />
        </div>
      </div>
      <div style={{ maxHeight: open ? 2000 : 0, overflow: "hidden", transition: "max-height 0.4s cubic-bezier(.4,0,.2,1)" }}>
        <div style={{ padding: "0 14px 14px" }}>{children}</div>
      </div>
    </div>
  );
};

// ─── Grup Başlığı ───────────────────────────────────────────
const GroupHeader = ({ title, icon, color = "#0C6B58" }) => (
  <div style={{
    display: "flex", alignItems: "center", gap: 10,
    marginTop: 20, marginBottom: 6, padding: "10px 14px",
    background: color + "12", borderRadius: 12,
    borderLeft: `4px solid ${color}`,
  }}>
    <span style={{ fontSize: 20 }}>{icon}</span>
    <span style={{ fontSize: 14, fontWeight: 800, color, letterSpacing: "0.03em", textTransform: "uppercase" }}>{title}</span>
  </div>
);

// ─── Stat Row (iki sütun bilgi satırı) ──────────────────────
const StatRow = ({ items }) => (
  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
    {items.map((item, i) => (
      <div key={i} style={{ background: "#F8F6F2", borderRadius: 12, padding: "14px 16px" }}>
        <div style={{ fontSize: 13, color: "#9BA5AE", fontWeight: 500 }}>{item.label}</div>
        <div style={{ fontSize: 19, fontWeight: 800, color: item.color || "#1A1A1A", marginTop: 4 }}>{item.value}</div>
        {item.sub && <div style={{ fontSize: 12, color: "#9BA5AE", marginTop: 2 }}>{item.sub}</div>}
      </div>
    ))}
  </div>
);

const Spinner = () => (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200 }}>
    <div style={{ width: 36, height: 36, border: "3px solid #EDEBE7", borderTop: "3px solid #0C6B58", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
  </div>
);

// ── LOGIN PAGE ──────────────────────────────────────────────
function LoginPage({ username, setUsername, password, setPassword, otpRequired, otpCode, setOtpCode, otpMesaj, loginError, loginLoading, handleLogin, handleOtpVerify, onGeriDon }) {
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", padding: "0 24px", background: "linear-gradient(160deg, #0C6B58 0%, #085542 50%, #063D30 100%)" }}>
      <div style={{ textAlign: "center", marginBottom: 40, animation: "slideUp 0.6s both" }}>
        <div style={{ width: 72, height: 72, borderRadius: 20, background: "rgba(255,255,255,0.15)", display: "inline-flex", alignItems: "center", justifyContent: "center", marginBottom: 16 }}>
          <span style={{ fontSize: 32, fontWeight: 900, color: "#fff" }}>T</span>
        </div>
        <div style={{ fontSize: 28, fontWeight: 800, color: "#fff", letterSpacing: "-0.03em" }}>TİGEM SGB</div>
        <div style={{ fontSize: 14, color: "rgba(255,255,255,0.6)", marginTop: 4 }}>Mobil Dashboard</div>
      </div>
      <div style={{ background: "#fff", borderRadius: 24, padding: "32px 24px", boxShadow: "0 20px 60px rgba(0,0,0,0.3)", animation: "slideUp 0.6s 0.15s both" }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: "#1A1A1A", marginBottom: 24 }}>Giriş Yap</div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: "#5A6670", display: "block", marginBottom: 6 }}>KULLANICI ADI</label>
          <div style={{ display: "flex", alignItems: "center", border: "2px solid #E8E4DE", borderRadius: 12, padding: "0 14px" }}>
            <Icon type="user" size={18} color="#9BA5AE" />
            <input value={username} onChange={(e) => setUsername(e.target.value)} placeholder="kullanıcı adınız" onKeyDown={(e) => e.key === "Enter" && handleLogin()} style={{ flex: 1, border: "none", outline: "none", padding: "14px 10px", fontSize: 15, color: "#1A1A1A", background: "transparent" }} />
          </div>
        </div>
        <div style={{ marginBottom: 24 }}>
          <label style={{ fontSize: 12, fontWeight: 600, color: "#5A6670", display: "block", marginBottom: 6 }}>ŞİFRE</label>
          <div style={{ display: "flex", alignItems: "center", border: "2px solid #E8E4DE", borderRadius: 12, padding: "0 14px" }}>
            <Icon type="lock" size={18} color="#9BA5AE" />
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="şifreniz" onKeyDown={(e) => e.key === "Enter" && handleLogin()} style={{ flex: 1, border: "none", outline: "none", padding: "14px 10px", fontSize: 15, color: "#1A1A1A", background: "transparent" }} />
          </div>
        </div>
        {otpRequired ? (
          <>
            <div style={{ background: "#EAF4F0", color: "#0C6B58", padding: "10px 14px", borderRadius: 10, fontSize: 13, marginBottom: 16 }}>{otpMesaj}</div>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: "#5A6670", display: "block", marginBottom: 6 }}>DOĞRULAMA KODU</label>
              <div style={{ display: "flex", alignItems: "center", border: "2px solid #E8E4DE", borderRadius: 12, padding: "0 14px" }}>
                <Icon type="lock" size={18} color="#9BA5AE" />
                <input value={otpCode} onChange={(e) => setOtpCode(e.target.value)} placeholder="6 haneli kod" inputMode="numeric" maxLength={6} onKeyDown={(e) => e.key === "Enter" && handleOtpVerify()} style={{ flex: 1, border: "none", outline: "none", padding: "14px 10px", fontSize: 22, letterSpacing: 8, color: "#1A1A1A", background: "transparent" }} autoFocus />
              </div>
            </div>
            {loginError && <div style={{ background: "#FEF2F2", color: "#D4563A", padding: "10px 14px", borderRadius: 10, fontSize: 13, fontWeight: 500, marginBottom: 16 }}>{loginError}</div>}
            <button onClick={handleOtpVerify} disabled={loginLoading || otpCode.length < 6} style={{ width: "100%", padding: "15px", borderRadius: 12, border: "none", background: loginLoading ? "#9BA5AE" : "#0C6B58", color: "#fff", fontSize: 16, fontWeight: 700, cursor: "pointer", opacity: otpCode.length < 6 ? 0.5 : 1 }}>
              {loginLoading ? "Doğrulanıyor..." : "Kodu Onayla"}
            </button>
            <div onClick={onGeriDon} style={{ textAlign: "center", marginTop: 16, color: "#9BA5AE", fontSize: 13, cursor: "pointer" }}>← Geri dön</div>
          </>
        ) : (
          <>
            {loginError && <div style={{ background: "#FEF2F2", color: "#D4563A", padding: "10px 14px", borderRadius: 10, fontSize: 13, fontWeight: 500, marginBottom: 16 }}>{loginError}</div>}
            <button onClick={handleLogin} disabled={loginLoading || !username || !password} style={{ width: "100%", padding: "15px", borderRadius: 12, border: "none", background: loginLoading ? "#9BA5AE" : "#0C6B58", color: "#fff", fontSize: 16, fontWeight: 700, cursor: "pointer", opacity: (!username || !password) ? 0.5 : 1 }}>
              {loginLoading ? "Giriş yapılıyor..." : "Giriş Yap"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════
function TigemDashboardInner() {
  const [page, setPage] = useState("login");
  const [selectedIsletme, setSelectedIsletme] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [searchOpen, setSearchOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [loginLoading, setLoginLoading] = useState(false);
  const [otpRequired, setOtpRequired] = useState(false);
  const [otpCode, setOtpCode] = useState("");
  const [otpMesaj, setOtpMesaj] = useState("");
  const [user, setUser] = useState(null);
  const [ozet, setOzet] = useState(null);
  const [isletmeDetay, setIsletmeDetay] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [secilenYil, setSecilenYil] = useState(CURRENT_YEAR);
  const [secilenAy, setSecilenAy] = useState(0);
  const [filterOpen, setFilterOpen] = useState(false);
  const [pendingYil, setPendingYil] = useState(CURRENT_YEAR);
  const [pendingAy, setPendingAy] = useState(0);

  const handleLogout = () => {
    api._clear();
    setUser(null); setOzet(null); setPage("login");
    setUsername(""); setPassword("");
  };

  useEffect(() => {
    const savedToken = api.token;
    const savedUser  = api.user;
    if (savedToken && savedUser) {
      setUser(savedUser);
      setPage("home");
      loadOzet(CURRENT_YEAR, 0);
    }
  }, []); // eslint-disable-line

  const loadOzet = useCallback(async (yil, ay) => {
    const _yil = yil ?? CURRENT_YEAR;
    const _ay = ay ?? 0;
    setLoading(true); setError("");
    try {
      const url = `/api/mobil/ozet?yil=${_yil}${_ay > 0 ? `&ay=${_ay}` : ""}`;
      const data = await api.get(url);
      setOzet(data);
      setSecilenYil(_yil);
      setSecilenAy(_ay);
    } catch (e) {
      if (e.message === "UNAUTHORIZED") { api._clear(); setUser(null); setOzet(null); setPage("login"); return; }
      setError("Veri yüklenemedi: " + e.message);
    }
    setLoading(false);
  }, []); // eslint-disable-line

  const handleLogin = async () => {
    setLoginLoading(true); setLoginError("");
    try {
      const data = await api.login(username, password);
      if (data.otp_required) { setOtpRequired(true); setOtpMesaj(data.mesaj); }
      else { setUser(api.user); setPage("home"); loadOzet(CURRENT_YEAR, 0); }
    } catch (e) { setLoginError(e.message); }
    setLoginLoading(false);
  };

  const handleOtpVerify = async () => {
    setLoginLoading(true); setLoginError("");
    try {
      await api.verifyOtp(username, otpCode);
      setUser(api.user); setOtpRequired(false); setOtpCode(""); setPage("home"); loadOzet(CURRENT_YEAR, 0);
    } catch (e) { setLoginError(e.message); }
    setLoginLoading(false);
  };

  const loadIsletmeDetay = async (isletmeId) => {
    setLoading(true); setError("");
    try {
      const data = await api.get(`/api/mobil/isletme/${isletmeId}?yil=${secilenYil}`);
      setIsletmeDetay(data); setPage("detail");
    } catch (e) {
      if (e.message === "UNAUTHORIZED") { handleLogout(); return; }
      setError("Detay yüklenemedi: " + e.message);
    }
    setLoading(false);
  };

  // ── FİLTRE MODAL ─────────────────────────────────────────
  const AY_UZUN = ["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"];
  const FilterModal = () => {
    if (!filterOpen) return null;
    return (
      <>
        {/* arka plan overlay */}
        <div onClick={() => setFilterOpen(false)} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", zIndex: 200 }} />
        {/* bottom sheet */}
        <div style={{ position: "fixed", bottom: 0, left: "50%", transform: "translateX(-50%)", width: "100%", maxWidth: 480, background: "#fff", borderRadius: "20px 20px 0 0", padding: "20px 20px 32px", zIndex: 201, boxShadow: "0 -4px 30px rgba(0,0,0,0.15)" }}>
          <div style={{ width: 40, height: 4, background: "#E8E4DE", borderRadius: 2, margin: "0 auto 20px" }} />
          <div style={{ fontSize: 17, fontWeight: 700, color: "#1A1A1A", marginBottom: 16 }}>Dönem Seç</div>
          {/* Yıl seçimi */}
          <div style={{ fontSize: 12, fontWeight: 600, color: "#9BA5AE", marginBottom: 8, textTransform: "uppercase" }}>Yıl</div>
          <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
            {[2024, 2025, 2026].map(y => (
              <div key={y} onClick={() => setPendingYil(y)}
                style={{ flex: 1, textAlign: "center", padding: "10px 0", borderRadius: 12, fontWeight: 700, fontSize: 15, cursor: "pointer",
                  background: pendingYil === y ? "#0C6B58" : "#F0EDE8",
                  color: pendingYil === y ? "#fff" : "#5A6670" }}>
                {y}
              </div>
            ))}
          </div>
          {/* Ay seçimi */}
          <div style={{ fontSize: 12, fontWeight: 600, color: "#9BA5AE", marginBottom: 8, textTransform: "uppercase" }}>Ay</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 6, marginBottom: 20 }}>
            {[{ label: "Tüm Yıl", val: 0 }, ...AY_UZUN.map((a, i) => ({ label: a.slice(0,3), val: i+1 }))].map(({ label, val }) => (
              <div key={val} onClick={() => setPendingAy(val)}
                style={{ textAlign: "center", padding: "8px 4px", borderRadius: 10, fontWeight: 600, fontSize: 13, cursor: "pointer",
                  background: pendingAy === val ? "#0C6B58" : "#F0EDE8",
                  color: pendingAy === val ? "#fff" : "#5A6670" }}>
                {label}
              </div>
            ))}
          </div>
          <button onClick={() => { setFilterOpen(false); loadOzet(pendingYil, pendingAy); }}
            style={{ width: "100%", padding: 14, borderRadius: 14, border: "none", background: "#0C6B58", color: "#fff", fontSize: 16, fontWeight: 700, cursor: "pointer" }}>
            Uygula
          </button>
        </div>
      </>
    );
  };

  // ── HOME ─────────────────────────────────────────────────
  const HomePage = () => {
    if (loading && !ozet) return <Spinner />;
    if (!ozet) return <div style={{ padding: 20, textAlign: "center", color: "#5A6670" }}>{error || "Veri bulunamadı"}</div>;
    const bb = ozet.buyukbas || {};
    const kb = ozet.kucukbas || {};
    const tarla = ozet.tarla || {};
    const yem = ozet.yem || {};
    const bahce = ozet.bahce || {};
    const ari = ozet.ari || {};
    const at = ozet.at || {};
    const ceylan = ozet.ceylan || {};
    const kopek = ozet.kopek || {};
    const sut = ozet.sut || {};
    const donemLabel = secilenAy > 0 ? `${secilenYil} / ${AY_UZUN[secilenAy - 1]}` : `${secilenYil} Yılı`;
    return (
      <div style={{ padding: "0 14px 100px" }}>
        {/* Başlık */}
        <div style={{ padding: "20px 2px 16px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: 12, color: "#9BA5AE", fontWeight: 500 }}>Merhaba, {user?.ad_soyad}</div>
            <div style={{ fontSize: 22, fontWeight: 800, color: "#1A1A1A", letterSpacing: "-0.02em" }}>Özet Pano</div>
            <div style={{ fontSize: 12, color: "#0C6B58", fontWeight: 600, marginTop: 2 }}>{donemLabel}</div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <div onClick={() => { setPendingYil(secilenYil); setPendingAy(secilenAy); setFilterOpen(true); }}
              style={{ width: 36, height: 36, borderRadius: "50%", background: "#EDEBE7", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
              <Icon type="refresh" size={16} color="#5A6670" />
            </div>
            <div onClick={handleLogout} style={{ width: 36, height: 36, borderRadius: "50%", background: "#EDEBE7", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
              <Icon type="logout" size={16} color="#D4563A" />
            </div>
          </div>
        </div>
        {error && <div style={{ background: "#FEF2F2", color: "#D4563A", padding: "10px 14px", borderRadius: 10, fontSize: 13, marginBottom: 12 }}>{error}</div>}

        {/* 4 özet kart: İşletme / Arazi / Büyükbaş / Küçükbaş */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 4 }}>
          <div style={{ background: "#fff", borderRadius: 14, padding: "14px", display: "flex", alignItems: "center", gap: 12, border: "1px solid #E8E4DE" }}>
            <div style={{ width: 40, height: 40, borderRadius: 11, background: "#0C6B5818", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Icon type="building" size={20} color="#0C6B58" />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "#9BA5AE", fontWeight: 500 }}>Aktif İşletme</div>
              <div style={{ fontSize: 20, fontWeight: 800, color: "#1A1A1A" }}>{ozet.isletme_sayisi}</div>
              <div style={{ fontSize: 10, color: "#9BA5AE" }}>TİGEM</div>
            </div>
          </div>
          <div style={{ background: "#fff", borderRadius: 14, padding: "14px", display: "flex", alignItems: "center", gap: 12, border: "1px solid #E8E4DE" }}>
            <div style={{ width: 40, height: 40, borderRadius: 11, background: "#3478C618", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Icon type="land" size={20} color="#3478C6" />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "#9BA5AE", fontWeight: 500 }}>Toplam Arazi</div>
              <div style={{ fontSize: 20, fontWeight: 800, color: "#1A1A1A" }}>{fmt(Math.round(ozet.toplam_arazi_da || 0))}</div>
              <div style={{ fontSize: 10, color: "#9BA5AE" }}>dekar</div>
            </div>
          </div>
          <div style={{ background: "#fff", borderRadius: 14, padding: "14px", display: "flex", alignItems: "center", gap: 12, border: "1px solid #E8E4DE" }}>
            <div style={{ width: 40, height: 40, borderRadius: 11, background: "#D4563A18", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Icon type="cow" size={20} color="#D4563A" />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "#9BA5AE", fontWeight: 500 }}>Büyükbaş</div>
              <div style={{ fontSize: 20, fontWeight: 800, color: "#1A1A1A" }}>{fmt(bb.toplam_hayvan)}</div>
              <div style={{ fontSize: 10, color: "#9BA5AE" }}>baş</div>
            </div>
          </div>
          <div style={{ background: "#fff", borderRadius: 14, padding: "14px", display: "flex", alignItems: "center", gap: 12, border: "1px solid #E8E4DE" }}>
            <div style={{ width: 40, height: 40, borderRadius: 11, background: "#7C5CBF18", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Icon type="users" size={20} color="#7C5CBF" />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "#9BA5AE", fontWeight: 500 }}>Küçükbaş</div>
              <div style={{ fontSize: 20, fontWeight: 800, color: "#1A1A1A" }}>{fmt(kb.toplam_hayvan)}</div>
              <div style={{ display: "flex", gap: 6, marginTop: 1 }}>
                <span style={{ fontSize: 10, color: "#7C5CBF", fontWeight: 600 }}>🐑 {fmt(kb.koyun_toplam)}</span>
                <span style={{ fontSize: 10, color: "#5E3F99", fontWeight: 600 }}>🐐 {fmt(kb.keci_toplam)}</span>
              </div>
            </div>
          </div>
        </div>

        {/* ── HAYVANCILİK ──────────────────────────────── */}
        <GroupHeader title="Hayvancılık" icon="🐄" color="#D4563A" />

        {/* Büyükbaş */}
        <ExpandableSection title="Büyükbaş" badge={`${fmt(bb.toplam_hayvan)} baş`} color="#D4563A">
          <StatRow items={[
            { label: "Toplam Hayvan", value: fmt(bb.toplam_hayvan) + " baş", color: "#D4563A" },
            { label: "İnek", value: fmt(bb.toplam_inek) + " baş", color: "#B5432E" },
            { label: "Dişi (İnek+Düve)", value: fmt(bb.toplam_disi) + " baş", color: "#D4563A" },
            { label: "Erkek", value: fmt(bb.toplam_erkek) + " baş", color: "#3478C6" },
            { label: "Ticari Sığır", value: fmt(bb.toplam_ticari) + " baş", color: "#0C6B58" },
            { label: "Sağmal", value: fmt(bb.toplam_sagmal) + " baş", color: "#E8A838" },
          ]} />
          <div style={{ marginTop: 10 }}>
            <StatRow items={[
              { label: "Süt Üretimi", value: fmt(bb.toplam_sut_kg) + " kg", color: "#3478C6" },
              { label: "Buzağı Doğum", value: fmt(bb.toplam_buzagi) + " adet", color: "#E8A838" },
            ]} />
          </div>
          {ozet.aylik_buyukbas && (
            <>
              <MiniBar data={ozet.aylik_buyukbas} dataKey="toplam_hayvan" color="#D4563A" label="Aylık Hayvan Varlığı" />
              <MiniBar data={ozet.aylik_buyukbas} dataKey="sut_kg" color="#3478C6" label="Aylık Süt Üretimi (kg)" />
            </>
          )}
          {ozet.buyukbas_irk_detay?.length > 0 && (
            <div style={{ marginTop: 16 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: "#5A6670", marginBottom: 10, letterSpacing: "0.03em", textTransform: "uppercase" }}>Irk Dağılımı</div>
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {ozet.buyukbas_irk_detay.map((irk) => <IrkKart key={irk.irk} irk={irk} />)}
              </div>
            </div>
          )}
        </ExpandableSection>

        {/* Küçükbaş */}
        <ExpandableSection title="Küçükbaş" badge={`${fmt(kb.toplam_hayvan)} baş`} color="#7C5CBF">
          <StatRow items={[
            { label: "Toplam Hayvan", value: fmt(kb.toplam_hayvan) + " baş", color: "#7C5CBF" },
            { label: "Süt Üretimi", value: fmt(kb.toplam_sut_kg) + " kg", color: "#E8A838" },
          ]} />
          {kb.koyun_toplam > 0 && (
            <div style={{ marginTop: 12 }}>
              <SubSection title="🐑 Koyun" badge={`${fmt(kb.koyun_toplam)} baş`} color="#7C5CBF">
                <StatRow items={[
                  { label: "Toplam", value: fmt(kb.koyun_toplam) + " baş", color: "#7C5CBF" },
                  { label: "Süt", value: fmt(kb.koyun_sut_kg) + " kg", color: "#E8A838" },
                ]} />
                {ozet.kucukbas_koyun_irk?.length > 0 && (
                  <div style={{ marginTop: 10 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "#5A6670", marginBottom: 8, textTransform: "uppercase" }}>Irk Dağılımı</div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                      {ozet.kucukbas_koyun_irk.map(irk => <KucukbasIrkKart key={irk.irk} irk={irk} />)}
                    </div>
                  </div>
                )}
              </SubSection>
            </div>
          )}
          {kb.keci_toplam > 0 && (
            <div style={{ marginTop: 8 }}>
              <SubSection title="🐐 Keçi" badge={`${fmt(kb.keci_toplam)} baş`} color="#5E3F99">
                <StatRow items={[
                  { label: "Toplam", value: fmt(kb.keci_toplam) + " baş", color: "#5E3F99" },
                  { label: "Süt", value: fmt(kb.keci_sut_kg) + " kg", color: "#E8A838" },
                ]} />
                {ozet.kucukbas_keci_irk?.length > 0 && (
                  <div style={{ marginTop: 10 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "#5A6670", marginBottom: 8, textTransform: "uppercase" }}>Irk Dağılımı</div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                      {ozet.kucukbas_keci_irk.map(irk => <KucukbasIrkKart key={irk.irk} irk={irk} />)}
                    </div>
                  </div>
                )}
              </SubSection>
            </div>
          )}
        </ExpandableSection>

        {/* At Yetiştiriciliği */}
        {at.toplam_hayvan > 0 && (
          <ExpandableSection title="At Yetiştiriciliği" badge={`${fmt(at.toplam_hayvan)} baş`} color="#6C3483">
            <StatRow items={[
              { label: "Kısrak", value: fmt(at.toplam_kisrak) + " baş", color: "#6C3483" },
              { label: "Aygır", value: fmt(at.toplam_aygir) + " baş", color: "#4A235A" },
              { label: "Tay", value: fmt(at.toplam_tay) + " baş", color: "#9B59B6" },
              { label: "Tay Doğum", value: fmt(at.toplam_dogum) + " adet", color: "#E8A838" },
            ]} />
          </ExpandableSection>
        )}

        {/* Arıcılık */}
        {(ari.toplam_kovan > 0 || ari.toplam_bal_kg > 0) && (
          <ExpandableSection title="Arıcılık" badge={`${fmt(ari.toplam_kovan)} kovan`} color="#E8A838">
            <StatRow items={[
              { label: "Kovan Sayısı", value: fmt(ari.toplam_kovan), color: "#E8A838", sub: "adet" },
              { label: "Bal Üretimi", value: fmt(ari.toplam_bal_kg) + " kg", color: "#C48820" },
              { label: "Bal Satışı", value: fmt(ari.toplam_satis_kg) + " kg", color: "#A06010" },
            ]} />
          </ExpandableSection>
        )}

        {/* Asya Ceylanı */}
        {ceylan.toplam_bas > 0 && (
          <ExpandableSection title="Asya Ceylanı" badge={`${fmt(ceylan.toplam_bas)} baş`} color="#117A65">
            <StatRow items={[
              { label: "Toplam Baş", value: fmt(ceylan.toplam_bas) + " baş", color: "#117A65" },
              { label: "Doğum", value: fmt(ceylan.toplam_dogum) + " adet", color: "#0E6655" },
            ]} />
          </ExpandableSection>
        )}

        {/* Çoban Köpeği */}
        {kopek.toplam_bas > 0 && (
          <ExpandableSection title="Çoban Köpeği" badge={`${fmt(kopek.toplam_bas)} baş`} color="#7F8C8D">
            <StatRow items={[
              { label: "Toplam Baş", value: fmt(kopek.toplam_bas) + " baş", color: "#7F8C8D" },
              { label: "Doğum", value: fmt(kopek.toplam_dogum) + " adet", color: "#626567" },
            ]} />
          </ExpandableSection>
        )}

        {/* Süt Üretimi */}
        {sut.toplam_uretim_kg > 0 && (
          <ExpandableSection title="Süt Üretimi" badge={`${fmt(sut.toplam_uretim_kg)} kg`} color="#3478C6">
            <StatRow items={[
              { label: "Toplam Üretim", value: fmt(sut.toplam_uretim_kg) + " kg", color: "#3478C6" },
            ]} />
            {sut.detay?.length > 0 && (
              <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 6 }}>
                {sut.detay.map(d => (
                  <div key={d.tur} style={{ display: "flex", justifyContent: "space-between", padding: "8px 12px", background: "#F8F6F2", borderRadius: 10 }}>
                    <span style={{ fontSize: 13, fontWeight: 600, color: "#1A1A1A" }}>{d.tur}</span>
                    <span style={{ fontSize: 13, fontWeight: 700, color: "#3478C6" }}>{fmt(d.uretim_kg)} kg</span>
                  </div>
                ))}
              </div>
            )}
          </ExpandableSection>
        )}

        {/* ── BİTKİSEL ÜRETİM ──────────────────────────── */}
        <GroupHeader title="Bitkisel Üretim" icon="🌾" color="#6B8E23" />

        {(tarla.toplam_ekim_da > 0 || tarla.toplam_uretim_ton > 0) && (
          <ExpandableSection title="🌾 Tarla Bitkileri" badge={`${tarla.urun_sayisi||0} ürün`} color="#6B8E23">
            <StatRow items={[
              { label: "Hasat Alanı", value: fmtDa(tarla.toplam_ekim_da), color: "#6B8E23" },
              { label: "Üretim", value: fmt(tarla.toplam_uretim_ton) + " ton", color: "#4A6318" },
              { label: "Tohum", value: fmt(tarla.toplam_tohum_ton) + " ton", color: "#8FAF3A" },
              { label: "Çeşit", value: String(tarla.urun_sayisi || 0), color: "#6B8E23", sub: "ürün" },
            ]} />
            {tarla.urunler?.length > 0 && (
              <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
                {tarla.urunler.map(u => <UrunKart key={u.urun} urun={u} color="#6B8E23" />)}
              </div>
            )}
          </ExpandableSection>
        )}

        {(yem.toplam_alan_da > 0 || yem.toplam_uretim_ton > 0) && (
          <ExpandableSection title="🌿 Yem Bitkileri" badge={`${yem.urun_sayisi||0} ürün`} color="#5B8A3C">
            <StatRow items={[
              { label: "Toplam Alan", value: fmtDa(yem.toplam_alan_da), color: "#5B8A3C" },
              { label: "Üretim", value: fmt(yem.toplam_uretim_ton) + " ton", color: "#3A6022" },
            ]} />
            {yem.urunler?.length > 0 && (
              <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
                {yem.urunler.map(u => <UrunKart key={u.urun} urun={u} color="#5B8A3C" />)}
              </div>
            )}
          </ExpandableSection>
        )}

        {(bahce.toplam_alan_da > 0 || bahce.toplam_uretim_ton > 0) && (
          <ExpandableSection title="🍎 Bahçe Kültürleri" badge={`${bahce.urun_sayisi||0} ürün`} color="#C97B2E">
            <StatRow items={[
              { label: "Toplam Alan", value: fmtDa(bahce.toplam_alan_da), color: "#C97B2E" },
              { label: "Üretim", value: fmt(bahce.toplam_uretim_ton) + " ton", color: "#A55E18" },
            ]} />
            {bahce.urunler?.length > 0 && (
              <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
                {bahce.urunler.map(u => <UrunKart key={u.urun} urun={u} color="#C97B2E" />)}
              </div>
            )}
          </ExpandableSection>
        )}

        {tarla.toplam_ekim_da === 0 && tarla.toplam_uretim_ton === 0 && yem.toplam_alan_da === 0 && yem.toplam_uretim_ton === 0 && bahce.toplam_alan_da === 0 && bahce.toplam_uretim_ton === 0 && (
          <div style={{ textAlign: "center", padding: "16px", color: "#9BA5AE", fontSize: 13, background: "#fff", borderRadius: 14, border: "1px solid #E8E4DE" }}>
            {secilenYil} yılı için bitkisel üretim verisi girilmemiş
          </div>
        )}

        {/* ── VARLIKLAR ─────────────────────────────────── */}
        {ozet.varlik && (
          <>
            <GroupHeader title="Varlıklar" icon="🏗️" color="#3478C6" />
            <ExpandableSection title="🗺️ Arazi" badge={`${fmt(Math.round(ozet.varlik.toplam_arazi_da || 0))} da`} color="#3478C6">
              <StatRow items={[
                { label: "Toplam Arazi", value: fmt(Math.round(ozet.varlik.toplam_arazi_da)) + " da", color: "#3478C6" },
                { label: "Faal İşletme", value: fmt(Math.round(ozet.varlik.faal_arazi_da || 0)) + " da", color: "#0C6B58" },
                { label: "Kiralık", value: fmt(Math.round(ozet.varlik.kiralik_arazi_da || 0)) + " da", color: "#C97B2E" },
              ]} />
            </ExpandableSection>
            {ozet.varlik.toplam_makine > 0 && (
              <ExpandableSection title="🚜 Makine & Ekipman" badge={`${fmt(ozet.varlik.toplam_makine)} adet`} color="#5A6670">
                <StatRow items={[
                  { label: "Traktör", value: fmt(ozet.varlik.traktor_adet) + " adet", color: "#5A6670" },
                  { label: "Traktör Gücü", value: fmt(Math.round(ozet.varlik.traktor_guc_kw)) + " kW", color: "#3A4850" },
                  { label: "Toplam Makine", value: fmt(ozet.varlik.toplam_makine) + " adet", color: "#5A6670" },
                ]} />
              </ExpandableSection>
            )}
            {ozet.varlik.toplam_tasit > 0 && (
              <ExpandableSection title="🚗 Taşıtlar" badge={`${fmt(ozet.varlik.toplam_tasit)} adet`} color="#E8A838">
                <StatRow items={[
                  { label: "Toplam Taşıt", value: fmt(ozet.varlik.toplam_tasit) + " adet", color: "#E8A838" },
                  ...(ozet.varlik.tasit_detay || []).map(t => ({ label: t.label, value: t.adet + " adet", color: "#5A6670" })),
                ]} />
              </ExpandableSection>
            )}
            {ozet.varlik.tesis && (
              <ExpandableSection title="🏭 Tesis & Altyapı" color="#D4563A">
                {(() => {
                  const t = ozet.varlik.tesis || {};
                  return (
                    <>
                      <TesisGrupKart title="📦 Depolama Tesisleri" fields={[
                        { label: "Silo", value: t.silo_ton, sub: "ton" },
                        { label: "Hangar", value: t.hangar_m2, sub: "m²" },
                        { label: "Yem Ambarı", value: t.yem_ambar_m3, sub: "m³" },
                        { label: "Malzeme Ambarı", value: t.malzeme_ambar_m3, sub: "m³" },
                        { label: "Akaryakıt Tankı", value: t.akaryakit_tanki_m3, sub: "m³" },
                      ]} />
                      <TesisGrupKart title="⚙️ Üretim Tesisleri" fields={[
                        { label: "Tohum Hazırlama", value: t.tohum_hazirlama_ton_saat, sub: "ton/s" },
                        { label: "Mısır Kurutma", value: t.misir_kurutma_ton_saat, sub: "ton/s" },
                        { label: "Yem Hazırlama", value: t.yem_hazirlama_ton_saat, sub: "ton/s" },
                      ]} />
                      <TesisGrupKart title="🐄 Büyükbaş Barınakları" fields={[
                        { label: "Sağım Ahırı", value: t.sagim_ahiri_bas, sub: "baş" },
                        { label: "Besilik Ahırı", value: t.besilik_ahiri_bas, sub: "baş" },
                        { label: "Dana Ahırı", value: t.dana_ahiri_bas, sub: "baş" },
                        { label: "Buzağı Ahırı", value: t.buzagi_ahiri_bas, sub: "baş" },
                        { label: "Düve Ahırı", value: t.duve_ahiri_bas, sub: "baş" },
                      ]} />
                      <TesisGrupKart title="🐑 Küçükbaş Barınakları" fields={[
                        { label: "Ana Koyun/Keçi Ağılı", value: t.ana_koyun_agili_bas, sub: "baş" },
                        { label: "Kuzu/Oğlak Ağılı", value: t.kuzu_oglak_agili_bas, sub: "baş" },
                        { label: "Koç/Teke Ağılı", value: t.koc_teke_agili_bas, sub: "baş" },
                      ]} />
                      <TesisGrupKart title="🐴 At Barınakları" fields={[
                        { label: "Kısrak Tavlası", value: t.kisrak_tavlasi_bas, sub: "baş" },
                        { label: "Tay Tavlası", value: t.tay_tavlasi_bas, sub: "baş" },
                        { label: "Aygır Tavlası", value: t.aygir_tavlasi_bas, sub: "baş" },
                      ]} />
                    </>
                  );
                })()}
              </ExpandableSection>
            )}
          </>
        )}
      </div>
    );
  };

  // ── İŞLETMELER ──────────────────────────────────────────
  const IsletmelerPage = () => {
    if (!ozet) return <Spinner />;
    const filtered = (ozet.isletmeler || []).filter(
      (i) => i.ad.toLowerCase().includes(searchText.toLowerCase()) ||
             (i.il || "").toLowerCase().includes(searchText.toLowerCase())
    );
    const GRUPLAR = [
      { tip: "Faal",    renk: "#0C6B58", bg: "#EAF4F0" },
      { tip: "Merkez",  renk: "#3478C6", bg: "#EBF3FC" },
      { tip: "Kiralık", renk: "#C97B2E", bg: "#FEF3E2" },
    ];
    const IsletmeKart = ({ isl, idx }) => (
      <div key={isl.id} onClick={() => loadIsletmeDetay(isl.id)}
        style={{ background: "#fff", borderRadius: 14, padding: "14px 16px", display: "flex", alignItems: "center", gap: 12, cursor: "pointer", border: "1px solid #E8E4DE", animation: `slideUp 0.4s ${idx * 0.03}s both cubic-bezier(.4,0,.2,1)` }}>
        <div style={{ width: 42, height: 42, borderRadius: 11, background: `hsl(${(isl.id * 47) % 360}, 45%, 92%)`, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: 14, color: `hsl(${(isl.id * 47) % 360}, 50%, 35%)`, flexShrink: 0 }}>
          {(isl.kod || isl.ad).slice(0, 3)}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#1A1A1A", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{isl.ad}</div>
          <div style={{ fontSize: 11, color: "#9BA5AE", marginTop: 2 }}>{isl.il}{isl.ilce ? ` / ${isl.ilce}` : ""}{isl.mudur ? ` · ${isl.mudur}` : ""}</div>
        </div>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9BA5AE" strokeWidth="2.5" strokeLinecap="round"><path d="M9 18l6-6-6-6" /></svg>
      </div>
    );
    return (
      <div style={{ padding: "0 14px 100px" }}>
        <div style={{ padding: "20px 2px 12px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div>
            <div style={{ fontSize: 22, fontWeight: 800, color: "#1A1A1A" }}>İşletmeler</div>
            <div style={{ fontSize: 12, color: "#0C6B58", fontWeight: 600, marginTop: 2 }}>{secilenAy > 0 ? `${secilenYil} / ${AY_UZUN[secilenAy - 1]}` : `${secilenYil} Yılı`}</div>
          </div>
          <div onClick={() => setSearchOpen(!searchOpen)} style={{ width: 36, height: 36, borderRadius: "50%", background: "#EDEBE7", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
            <Icon type={searchOpen ? "close" : "search"} size={18} color="#5A6670" />
          </div>
        </div>
        {searchOpen && (
          <input autoFocus value={searchText} onChange={(e) => setSearchText(e.target.value)} placeholder="İşletme veya il ara..."
            style={{ width: "100%", padding: "12px 16px", borderRadius: 12, border: "2px solid #0C6B58", background: "#fff", fontSize: 15, color: "#1A1A1A", outline: "none", marginBottom: 10, boxSizing: "border-box" }} />
        )}
        {loading && <div style={{ textAlign: "center", padding: "20px", color: "#0C6B58", fontSize: 13 }}>Yükleniyor...</div>}
        {error && <div style={{ background: "#FEF2F2", color: "#D4563A", padding: "10px 14px", borderRadius: 10, fontSize: 13, marginBottom: 12 }}>{error}</div>}
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {GRUPLAR.map(({ tip, renk, bg }) => {
            const liste = filtered.filter(i => i.tip === tip);
            if (liste.length === 0) return null;
            return (
              <div key={tip}>
                <div style={{ padding: "7px 12px", borderRadius: 10, background: bg, color: renk, fontSize: 12, fontWeight: 700, letterSpacing: "0.04em", textTransform: "uppercase", marginBottom: 8 }}>
                  {tip} İşletmeler — {liste.length} adet
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  {liste.map((isl, idx) => <IsletmeKart key={isl.id} isl={isl} idx={idx} />)}
                </div>
              </div>
            );
          })}
          {/* Diğer tipler (beklenmedik) */}
          {filtered.filter(i => !["Faal","Merkez","Kiralık"].includes(i.tip)).map((isl, idx) => (
            <IsletmeKart key={isl.id} isl={isl} idx={idx} />
          ))}
          {filtered.length === 0 && <div style={{ textAlign: "center", color: "#9BA5AE", padding: 40 }}>Sonuç bulunamadı</div>}
        </div>
      </div>
    );
  };

  // ── DETAY ────────────────────────────────────────────────
  const DetailPage = () => {
    if (loading || !isletmeDetay) return <Spinner />;
    const isl = isletmeDetay.isletme;
    const bb  = isletmeDetay.buyukbas || {};
    const kb  = isletmeDetay.kucukbas || {};
    const tarla = isletmeDetay.tarla || {};
    const yem   = isletmeDetay.yem || {};
    const bahce = isletmeDetay.bahce || {};
    const ari   = isletmeDetay.ari || {};
    const vrl   = isletmeDetay.varlik || {};
    const dat   = isletmeDetay.at || {};
    const dceylan = isletmeDetay.ceylan || {};
    const dkopek  = isletmeDetay.kopek || {};
    const dsut    = isletmeDetay.sut || {};
    const hayvanVar = bb.toplam_hayvan > 0 || kb.toplam_hayvan > 0 || dat.toplam_hayvan > 0 || ari.toplam_kovan > 0 || dceylan.toplam_bas > 0 || dkopek.toplam_bas > 0 || dsut.toplam_uretim_kg > 0;
    const bitkiselVar = tarla.toplam_ekim_da > 0 || tarla.toplam_uretim_ton > 0 || yem.toplam_alan_da > 0 || yem.toplam_uretim_ton > 0 || bahce.toplam_alan_da > 0 || bahce.toplam_uretim_ton > 0;
    const varlikVar = !!(vrl.arazi || vrl.toplam_makine > 0 || vrl.toplam_tasit > 0);

    return (
      <div style={{ padding: "0 14px 100px" }}>
        <div onClick={() => setPage("isletmeler")} style={{ padding: "14px 2px", display: "flex", alignItems: "center", gap: 8, cursor: "pointer", color: "#0C6B58", fontSize: 14, fontWeight: 600 }}>
          <Icon type="back" size={18} color="#0C6B58" /> İşletmeler
        </div>

        {/* İşletme başlık kartı */}
        <div style={{ background: `linear-gradient(135deg, hsl(${((isl.id||1)*47)%360},40%,30%), hsl(${((isl.id||1)*47+40)%360},45%,22%))`, borderRadius: 18, padding: "20px", color: "#fff", marginBottom: 12 }}>
          <div style={{ fontSize: 11, opacity: 0.7, fontWeight: 500, letterSpacing: "0.05em", textTransform: "uppercase" }}>{isl.il}{isl.ilce ? ` / ${isl.ilce}` : ""}{isl.tip ? ` · ${isl.tip}` : ""}</div>
          <div style={{ fontSize: 22, fontWeight: 800, marginTop: 4 }}>{isl.ad}</div>
          {isl.mudur && <div style={{ fontSize: 12, opacity: 0.8, marginTop: 6 }}>Müdür: {isl.mudur}</div>}
        </div>

        {!hayvanVar && !bitkiselVar && !varlikVar && (
          <div style={{ textAlign: "center", color: "#9BA5AE", padding: "40px 20px", background: "#fff", borderRadius: 16, border: "1px solid #E8E4DE" }}>
            Bu işletme için {secilenYil} yılına ait veri bulunamadı.
          </div>
        )}

        {/* ── HAYVANCILİK ──────────────────────────────── */}
        {hayvanVar && <GroupHeader title="Hayvancılık" icon="🐄" color="#D4563A" />}

        {bb.toplam_hayvan > 0 && (
          <ExpandableSection title="Büyükbaş" badge={`${fmt(bb.toplam_hayvan)} baş`} color="#D4563A">
            <StatRow items={[
              { label: "Toplam Hayvan", value: fmt(bb.toplam_hayvan) + " baş", color: "#D4563A" },
              { label: "İnek", value: fmt(bb.toplam_inek) + " baş", color: "#B5432E" },
              { label: "Dişi (İnek+Düve)", value: fmt(bb.toplam_disi) + " baş", color: "#D4563A" },
              { label: "Erkek", value: fmt(bb.toplam_erkek) + " baş", color: "#3478C6" },
              { label: "Sağmal", value: fmt(bb.toplam_sagmal) + " baş", color: "#E8A838" },
              { label: "Süt Üretimi", value: fmt(bb.toplam_sut_kg) + " kg", color: "#3478C6" },
            ]} />
            {isletmeDetay.aylik_buyukbas && (
              <>
                <MiniBar data={isletmeDetay.aylik_buyukbas} dataKey="toplam_hayvan" color="#D4563A" label="Aylık Hayvan Varlığı" />
                <MiniBar data={isletmeDetay.aylik_buyukbas} dataKey="sut_kg" color="#3478C6" label="Aylık Süt Üretimi (kg)" />
              </>
            )}
            {isletmeDetay.buyukbas_irk_detay?.length > 0 && (
              <div style={{ marginTop: 16 }}>
                <div style={{ fontSize: 13, fontWeight: 700, color: "#5A6670", marginBottom: 10, letterSpacing: "0.03em", textTransform: "uppercase" }}>Irk Dağılımı</div>
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  {isletmeDetay.buyukbas_irk_detay.map(irk => <IrkKart key={irk.irk} irk={irk} />)}
                </div>
              </div>
            )}
          </ExpandableSection>
        )}

        {kb.toplam_hayvan > 0 && (
          <ExpandableSection title="Küçükbaş" badge={`${fmt(kb.toplam_hayvan)} baş`} color="#7C5CBF">
            <StatRow items={[
              { label: "Toplam Hayvan", value: fmt(kb.toplam_hayvan) + " baş", color: "#7C5CBF" },
              { label: "Süt Üretimi", value: fmt(kb.toplam_sut_kg) + " kg", color: "#E8A838" },
            ]} />
            {kb.koyun_toplam > 0 && (
              <div style={{ marginTop: 12 }}>
                <SubSection title="🐑 Koyun" badge={`${fmt(kb.koyun_toplam)} baş`} color="#7C5CBF">
                  <StatRow items={[
                    { label: "Toplam", value: fmt(kb.koyun_toplam) + " baş", color: "#7C5CBF" },
                    { label: "Süt", value: fmt(kb.koyun_sut_kg) + " kg", color: "#E8A838" },
                  ]} />
                  {isletmeDetay.kucukbas_koyun_irk?.length > 0 && (
                    <div style={{ marginTop: 10 }}>
                      <div style={{ fontSize: 12, fontWeight: 700, color: "#5A6670", marginBottom: 8, textTransform: "uppercase" }}>Irk Dağılımı</div>
                      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                        {isletmeDetay.kucukbas_koyun_irk.map(irk => <KucukbasIrkKart key={irk.irk} irk={irk} />)}
                      </div>
                    </div>
                  )}
                </SubSection>
              </div>
            )}
            {kb.keci_toplam > 0 && (
              <div style={{ marginTop: 8 }}>
                <SubSection title="🐐 Keçi" badge={`${fmt(kb.keci_toplam)} baş`} color="#5E3F99">
                  <StatRow items={[
                    { label: "Toplam", value: fmt(kb.keci_toplam) + " baş", color: "#5E3F99" },
                    { label: "Süt", value: fmt(kb.keci_sut_kg) + " kg", color: "#E8A838" },
                  ]} />
                  {isletmeDetay.kucukbas_keci_irk?.length > 0 && (
                    <div style={{ marginTop: 10 }}>
                      <div style={{ fontSize: 12, fontWeight: 700, color: "#5A6670", marginBottom: 8, textTransform: "uppercase" }}>Irk Dağılımı</div>
                      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                        {isletmeDetay.kucukbas_keci_irk.map(irk => <KucukbasIrkKart key={irk.irk} irk={irk} />)}
                      </div>
                    </div>
                  )}
                </SubSection>
              </div>
            )}
            {isletmeDetay.aylik_kucukbas && (
              <MiniBar data={isletmeDetay.aylik_kucukbas} dataKey="toplam_hayvan" color="#7C5CBF" label="Aylık Hayvan Sayısı" />
            )}
          </ExpandableSection>
        )}

        {dat.toplam_hayvan > 0 && (
          <ExpandableSection title="At Yetiştiriciliği" badge={`${fmt(dat.toplam_hayvan)} baş`} color="#6C3483">
            <StatRow items={[
              { label: "Kısrak", value: fmt(dat.toplam_kisrak) + " baş", color: "#6C3483" },
              { label: "Aygır", value: fmt(dat.toplam_aygir) + " baş", color: "#4A235A" },
              { label: "Tay", value: fmt(dat.toplam_tay) + " baş", color: "#9B59B6" },
              { label: "Tay Doğum", value: fmt(dat.toplam_dogum) + " adet", color: "#E8A838" },
            ]} />
          </ExpandableSection>
        )}

        {ari.toplam_kovan > 0 && (
          <ExpandableSection title="Arıcılık" badge={`${fmt(ari.toplam_kovan)} kovan`} color="#E8A838">
            <StatRow items={[
              { label: "Kovan", value: fmt(ari.toplam_kovan) + " adet", color: "#E8A838" },
              { label: "Bal Üretimi", value: fmt(ari.toplam_bal_kg) + " kg", color: "#C48820" },
              { label: "Bal Satışı", value: fmt(ari.toplam_satis_kg) + " kg", color: "#A06010" },
            ]} />
          </ExpandableSection>
        )}

        {dceylan.toplam_bas > 0 && (
          <ExpandableSection title="Asya Ceylanı" badge={`${fmt(dceylan.toplam_bas)} baş`} color="#117A65">
            <StatRow items={[
              { label: "Toplam Baş", value: fmt(dceylan.toplam_bas) + " baş", color: "#117A65" },
              { label: "Doğum", value: fmt(dceylan.toplam_dogum) + " adet", color: "#0E6655" },
            ]} />
          </ExpandableSection>
        )}

        {dkopek.toplam_bas > 0 && (
          <ExpandableSection title="Çoban Köpeği" badge={`${fmt(dkopek.toplam_bas)} baş`} color="#7F8C8D">
            <StatRow items={[
              { label: "Toplam Baş", value: fmt(dkopek.toplam_bas) + " baş", color: "#7F8C8D" },
              { label: "Doğum", value: fmt(dkopek.toplam_dogum) + " adet", color: "#626567" },
            ]} />
          </ExpandableSection>
        )}

        {dsut.toplam_uretim_kg > 0 && (
          <ExpandableSection title="Süt Üretimi" badge={`${fmt(dsut.toplam_uretim_kg)} kg`} color="#3478C6">
            <StatRow items={[
              { label: "Toplam Üretim", value: fmt(dsut.toplam_uretim_kg) + " kg", color: "#3478C6" },
            ]} />
            {dsut.detay?.length > 0 && (
              <div style={{ marginTop: 10, display: "flex", flexDirection: "column", gap: 6 }}>
                {dsut.detay.map(d => (
                  <div key={d.tur} style={{ display: "flex", justifyContent: "space-between", padding: "8px 12px", background: "#F8F6F2", borderRadius: 10 }}>
                    <span style={{ fontSize: 13, fontWeight: 600, color: "#1A1A1A" }}>{d.tur}</span>
                    <span style={{ fontSize: 13, fontWeight: 700, color: "#3478C6" }}>{fmt(d.uretim_kg)} kg</span>
                  </div>
                ))}
              </div>
            )}
          </ExpandableSection>
        )}

        {/* ── BİTKİSEL ÜRETİM ──────────────────────────── */}
        <GroupHeader title="Bitkisel Üretim" icon="🌾" color="#6B8E23" />

        {(tarla.toplam_ekim_da > 0 || tarla.toplam_uretim_ton > 0) && (
          <ExpandableSection title="🌾 Tarla Bitkileri" badge={`${tarla.urun_sayisi||0} ürün`} color="#6B8E23">
            <StatRow items={[
              { label: "Hasat Alanı", value: fmtDa(tarla.toplam_ekim_da), color: "#6B8E23" },
              { label: "Üretim", value: fmt(tarla.toplam_uretim_ton) + " ton", color: "#4A6318" },
            ]} />
            {tarla.urunler?.length > 0 && (
              <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
                {tarla.urunler.map(u => <UrunKart key={u.urun} urun={u} color="#6B8E23" />)}
              </div>
            )}
          </ExpandableSection>
        )}

        {(yem.toplam_alan_da > 0 || yem.toplam_uretim_ton > 0) && (
          <ExpandableSection title="🌿 Yem Bitkileri" badge={`${yem.urun_sayisi||0} ürün`} color="#5B8A3C">
            <StatRow items={[
              { label: "Toplam Alan", value: fmtDa(yem.toplam_alan_da), color: "#5B8A3C" },
              { label: "Üretim", value: fmt(yem.toplam_uretim_ton) + " ton", color: "#3A6022" },
            ]} />
            {yem.urunler?.length > 0 && (
              <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
                {yem.urunler.map(u => <UrunKart key={u.urun} urun={u} color="#5B8A3C" />)}
              </div>
            )}
          </ExpandableSection>
        )}

        {(bahce.toplam_alan_da > 0 || bahce.toplam_uretim_ton > 0) && (
          <ExpandableSection title="🍎 Bahçe Kültürleri" badge={`${bahce.urun_sayisi||0} ürün`} color="#C97B2E">
            <StatRow items={[
              { label: "Toplam Alan", value: fmtDa(bahce.toplam_alan_da), color: "#C97B2E" },
              { label: "Üretim", value: fmt(bahce.toplam_uretim_ton) + " ton", color: "#A55E18" },
            ]} />
            {bahce.urunler?.length > 0 && (
              <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
                {bahce.urunler.map(u => <UrunKart key={u.urun} urun={u} color="#C97B2E" />)}
              </div>
            )}
          </ExpandableSection>
        )}

        {tarla.toplam_ekim_da === 0 && tarla.toplam_uretim_ton === 0 && yem.toplam_alan_da === 0 && yem.toplam_uretim_ton === 0 && bahce.toplam_alan_da === 0 && bahce.toplam_uretim_ton === 0 && (
          <div style={{ textAlign: "center", padding: "16px", color: "#9BA5AE", fontSize: 13, background: "#fff", borderRadius: 14, border: "1px solid #E8E4DE" }}>
            {secilenYil} yılı için bitkisel üretim verisi girilmemiş
          </div>
        )}

        {/* ── VARLIKLAR ─────────────────────────────────── */}
        {varlikVar && (
          <>
            <GroupHeader title="Varlıklar" icon="🏗️" color="#3478C6" />
            {vrl.arazi && vrl.arazi.toplam_da > 0 && (
              <ExpandableSection title="🗺️ Arazi" badge={`${fmt(Math.round(vrl.arazi.toplam_da))} da`} color="#3478C6">
                <StatRow items={[
                  { label: "Toplam Arazi", value: fmt(Math.round(vrl.arazi.toplam_da)) + " da", color: "#3478C6" },
                  { label: "Tarla", value: fmt(Math.round(vrl.arazi.tarla_da || 0)) + " da", color: "#6B8E23" },
                  { label: "Yem Bitkisi", value: fmt(Math.round(vrl.arazi.yem_da || 0)) + " da", color: "#5B8A3C" },
                  { label: "Mera", value: fmt(Math.round(vrl.arazi.mera_da || 0)) + " da", color: "#8FAF3A" },
                  { label: "Bahçe", value: fmt(Math.round(vrl.arazi.bahce_da || 0)) + " da", color: "#C97B2E" },
                ].filter(i => parseFloat(i.value) > 0)} />
              </ExpandableSection>
            )}
            {vrl.toplam_makine > 0 && (
              <ExpandableSection title="🚜 Makine & Ekipman" badge={`${fmt(vrl.toplam_makine)} adet`} color="#5A6670">
                <StatRow items={[
                  { label: "Traktör", value: fmt(vrl.traktor_adet) + " adet", color: "#5A6670" },
                  { label: "Traktör Gücü", value: fmt(Math.round(vrl.traktor_guc_kw)) + " kW", color: "#3A4850" },
                  { label: "Toplam Makine", value: fmt(vrl.toplam_makine) + " adet", color: "#5A6670" },
                ]} />
              </ExpandableSection>
            )}
            {vrl.toplam_tasit > 0 && (
              <ExpandableSection title="🚗 Taşıtlar" badge={`${fmt(vrl.toplam_tasit)} adet`} color="#E8A838">
                <StatRow items={[
                  { label: "Toplam Taşıt", value: fmt(vrl.toplam_tasit) + " adet", color: "#E8A838" },
                  ...(vrl.tasit_detay || []).map(t => ({ label: t.label, value: t.adet + " adet", color: "#5A6670" })),
                ]} />
              </ExpandableSection>
            )}
            {vrl.tesis && Object.values(vrl.tesis).some(v => v > 0) && (
              <ExpandableSection title="🏭 Tesis & Altyapı" color="#D4563A">
                {(() => {
                  const t = vrl.tesis;
                  return (
                    <>
                      <TesisGrupKart title="📦 Depolama Tesisleri" fields={[
                        { label: "Silo", value: t.silo_ton, sub: "ton" },
                        { label: "Hangar", value: t.hangar_m2, sub: "m²" },
                        { label: "Yem Ambarı", value: t.yem_ambar_m3, sub: "m³" },
                        { label: "Malzeme Ambarı", value: t.malzeme_ambar_m3, sub: "m³" },
                        { label: "Akaryakıt Tankı", value: t.akaryakit_tanki_m3, sub: "m³" },
                      ]} />
                      <TesisGrupKart title="⚙️ Üretim Tesisleri" fields={[
                        { label: "Tohum Hazırlama", value: t.tohum_hazirlama_ton_saat, sub: "ton/s" },
                        { label: "Mısır Kurutma", value: t.misir_kurutma_ton_saat, sub: "ton/s" },
                        { label: "Yem Hazırlama", value: t.yem_hazirlama_ton_saat, sub: "ton/s" },
                      ]} />
                      <TesisGrupKart title="🐄 Büyükbaş Barınakları" fields={[
                        { label: "Sağım Ahırı", value: t.sagim_ahiri_bas, sub: "baş" },
                        { label: "Besilik Ahırı", value: t.besilik_ahiri_bas, sub: "baş" },
                        { label: "Dana Ahırı", value: t.dana_ahiri_bas, sub: "baş" },
                        { label: "Buzağı Ahırı", value: t.buzagi_ahiri_bas, sub: "baş" },
                        { label: "Düve Ahırı", value: t.duve_ahiri_bas, sub: "baş" },
                      ]} />
                      <TesisGrupKart title="🐑 Küçükbaş Barınakları" fields={[
                        { label: "Ana Koyun/Keçi Ağılı", value: t.ana_koyun_agili_bas, sub: "baş" },
                        { label: "Kuzu/Oğlak Ağılı", value: t.kuzu_oglak_agili_bas, sub: "baş" },
                        { label: "Koç/Teke Ağılı", value: t.koc_teke_agili_bas, sub: "baş" },
                      ]} />
                      <TesisGrupKart title="🐴 At Barınakları" fields={[
                        { label: "Kısrak Tavlası", value: t.kisrak_tavlasi_bas, sub: "baş" },
                        { label: "Tay Tavlası", value: t.tay_tavlasi_bas, sub: "baş" },
                        { label: "Aygır Tavlası", value: t.aygir_tavlasi_bas, sub: "baş" },
                      ]} />
                    </>
                  );
                })()}
              </ExpandableSection>
            )}
          </>
        )}
      </div>
    );
  };

  // ── ÜRETİM ──────────────────────────────────────────────
  const UretimPage = () => {
    if (!ozet) return <Spinner />;
    const bb = ozet.buyukbas || {};
    const kb = ozet.kucukbas || {};
    const tarla = ozet.tarla || {};
    const yem = ozet.yem || {};
    const bahce = ozet.bahce || {};
    const ari = ozet.ari || {};
    return (
      <div style={{ padding: "0 14px 100px" }}>
        <div style={{ padding: "20px 2px 16px" }}>
          <div style={{ fontSize: 22, fontWeight: 800, color: "#1A1A1A" }}>Üretim Verileri</div>
          <div style={{ fontSize: 12, color: "#9BA5AE", marginTop: 3 }}>{CURRENT_YEAR} yılı</div>
        </div>

        {/* Hayvancılık özet */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 12 }}>
          {[
            { label: "BB Hayvan", value: fmt(bb.toplam_hayvan) + " baş", gradient: "linear-gradient(135deg, #D4563A, #B5432E)" },
            { label: "BB Süt", value: fmt(bb.toplam_sut_kg) + " kg", gradient: "linear-gradient(135deg, #3478C6, #2360A0)" },
            { label: "KB Hayvan", value: fmt(kb.toplam_hayvan) + " baş", gradient: "linear-gradient(135deg, #7C5CBF, #5E3F99)" },
            { label: "KB Süt", value: fmt(kb.toplam_sut_kg) + " kg", gradient: "linear-gradient(135deg, #E8A838, #C48820)" },
          ].map((item) => (
            <div key={item.label} style={{ background: item.gradient, borderRadius: 14, padding: "16px 16px", color: "#fff" }}>
              <div style={{ fontSize: 10, opacity: 0.75, fontWeight: 500, letterSpacing: "0.05em", textTransform: "uppercase" }}>{item.label}</div>
              <div style={{ fontSize: 20, fontWeight: 800, marginTop: 5 }}>{item.value}</div>
            </div>
          ))}
        </div>

        {/* Büyükbaş Detay */}
        <ExpandableSection title="Büyükbaş Detay" color="#D4563A">
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 12 }}>
            <CircleProgress value={bb.toplam_inek || 0} max={Math.max(bb.toplam_hayvan || 1, 1)} color="#D4563A" label="İnek" sub="baş" />
            <CircleProgress value={bb.toplam_buzagi || 0} max={Math.max(bb.toplam_inek || 1, 1)} color="#E8A838" label="Buzağı" sub="doğum" />
          </div>
          {ozet.aylik_buyukbas && (
            <>
              <MiniBar data={ozet.aylik_buyukbas} dataKey="sut_kg" color="#3478C6" label="BB Süt (kg)" />
              <MiniBar data={ozet.aylik_buyukbas} dataKey="buzagi" color="#E8A838" label="Buzağı Doğum" />
            </>
          )}
        </ExpandableSection>

        {/* Küçükbaş Detay */}
        <ExpandableSection title="Küçükbaş Detay" color="#7C5CBF">
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <CircleProgress value={kb.toplam_ana || 0} max={Math.max(kb.toplam_hayvan || 1, 1)} color="#7C5CBF" label="Ana Hayvan" sub="baş" />
            <CircleProgress value={kb.toplam_dogum || 0} max={Math.max(kb.toplam_ana || 1, 1)} color="#0C6B58" label="Doğum" sub="adet" />
          </div>
        </ExpandableSection>

        {/* Bitkisel Üretim */}
        {(tarla.toplam_ekim_da > 0 || yem.toplam_alan_da > 0 || bahce.toplam_alan_da > 0) && (
          <ExpandableSection title="Bitkisel Üretim" color="#6B8E23">
            <StatRow items={[
              { label: "Tarla Ekimi", value: fmtDa(tarla.toplam_ekim_da), color: "#6B8E23" },
              { label: "Tarla Üretimi", value: fmt(tarla.toplam_uretim_ton) + " ton", color: "#4A6318" },
              { label: "Yem Bitkisi", value: fmtDa(yem.toplam_alan_da), color: "#5B8A3C" },
              { label: "Yem Üretimi", value: fmt(yem.toplam_uretim_ton) + " ton", color: "#3A6022" },
              { label: "Bahçe Alanı", value: fmtDa(bahce.toplam_alan_da), color: "#C97B2E" },
              { label: "Bahçe Üretimi", value: fmt(bahce.toplam_uretim_ton) + " ton", color: "#A55E18" },
            ]} />
            {tarla.urunler && tarla.urunler.length > 0 && (
              <div style={{ marginTop: 14 }}>
                <div style={{ fontSize: 12, fontWeight: 600, color: "#5A6670", marginBottom: 8 }}>En Çok Üretilen Tarla Ürünleri</div>
                {tarla.urunler.map((u, i) => (
                  <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "7px 0", borderBottom: i < tarla.urunler.length - 1 ? "1px solid #F0EDE8" : "none" }}>
                    <span style={{ fontSize: 13, fontWeight: 600, color: "#1A1A1A" }}>{u.urun}</span>
                    <span style={{ fontSize: 13, fontWeight: 700, color: "#6B8E23" }}>{fmt(u.uretim_ton)} ton</span>
                  </div>
                ))}
              </div>
            )}
          </ExpandableSection>
        )}

        {/* Arıcılık */}
        {ari.toplam_kovan > 0 && (
          <ExpandableSection title="Arıcılık" badge={`${fmt(ari.toplam_kovan)} kovan`} color="#E8A838">
            <StatRow items={[
              { label: "Kovan Sayısı", value: fmt(ari.toplam_kovan) + " adet", color: "#E8A838" },
              { label: "Bal Üretimi", value: fmt(ari.toplam_bal_kg) + " kg", color: "#C48820" },
              { label: "Bal Satışı", value: fmt(ari.toplam_satis_kg) + " kg", color: "#A06010" },
            ]} />
          </ExpandableSection>
        )}
      </div>
    );
  };

  const tabs = [
    { id: "home", icon: "home", label: "Özet" },
    { id: "isletmeler", icon: "building", label: "İşletmeler" },
    { id: "uretim", icon: "chart", label: "Üretim" },
  ];

  return (
    <div style={{ fontFamily: "'DM Sans', 'Segoe UI', -apple-system, sans-serif", background: page === "login" ? "transparent" : "#F6F4F0", minHeight: "100vh", maxWidth: 480, margin: "0 auto", position: "relative", color: "#1A1A1A", overflowX: "hidden" }}>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes slideUp { from { opacity: 0; transform: translateY(14px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
      {page === "login" && (
        <LoginPage
          username={username} setUsername={setUsername}
          password={password} setPassword={setPassword}
          otpRequired={otpRequired} otpCode={otpCode} setOtpCode={setOtpCode}
          otpMesaj={otpMesaj} loginError={loginError} loginLoading={loginLoading}
          handleLogin={handleLogin} handleOtpVerify={handleOtpVerify}
          onGeriDon={() => { setOtpRequired(false); setOtpCode(""); setLoginError(""); }}
        />
      )}
      <FilterModal />
      {page === "home" && <HomePage />}
      {page === "isletmeler" && <IsletmelerPage />}
      {page === "detail" && <DetailPage />}
      {page === "uretim" && <UretimPage />}
      {page !== "login" && (
        <div style={{ position: "fixed", bottom: 0, left: "50%", transform: "translateX(-50%)", width: "100%", maxWidth: 480, background: "rgba(255,255,255,0.94)", backdropFilter: "blur(20px)", WebkitBackdropFilter: "blur(20px)", borderTop: "1px solid #E8E4DE", display: "flex", justifyContent: "space-around", padding: "8px 0 env(safe-area-inset-bottom, 12px)", zIndex: 100 }}>
          {tabs.map((tab) => {
            const active = page === tab.id || (tab.id === "isletmeler" && page === "detail");
            return (
              <div key={tab.id} onClick={() => { setPage(tab.id); setSearchOpen(false); setSearchText(""); }} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 3, cursor: "pointer", padding: "6px 20px", borderRadius: 12, background: active ? "#0C6B5812" : "transparent", transition: "all 0.2s" }}>
                <Icon type={tab.icon} size={22} color={active ? "#0C6B58" : "#9BA5AE"} />
                <span style={{ fontSize: 10, fontWeight: active ? 700 : 500, color: active ? "#0C6B58" : "#9BA5AE" }}>{tab.label}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default function TigemDashboard() {
  return (
    <ErrorBoundary>
      <TigemDashboardInner />
    </ErrorBoundary>
  );
}
